<template>
	<div id="usre-baseinfor" class="oh" v-title :data-title="title">
		<leftnav class="fl" mkcode='A' itemcode="A-XHSH"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" >
					<div class="right_boxtitle">
						<span class="fl right_title1" @click="routerself('/associationList')" style="margin-right: 30px;">协会</span>
						<span class="fl right_title1 current">商会</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">商会</span>
							<input type="text" placeholder="请输入商会名称" class="search-input"v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
						<video-teaching :type="1" seat="top"></video-teaching>
					</div>
					<div class="opport-screen-list1 qualityenterprise ">
						<dl class="opport-screen bdbe">
							<dt class="fl">家乡</dt>
							<dd class="fl">
								<span :class="hometid == 0?'current a-screen':'a-screen'"		@click="hometownchoosed(0);">全国地区</span>
								<span v-for="(item,index) in hometowndata"	@click="hometownchoosed(item.areaId);"	:class="item.areaId == hometid?'a-screen current' : 'a-screen'">{{item.areaName}}</span> 
							</dd>
						</dl>
						 <dl class="opport-screen bdbe">
						 	<dt class="fl">所在地</dt>
						 	<dd class="fl"> 
									<span :class="areaId == 0?'current a-screen':'a-screen'"		@click="areachoosed(0);">全部</span>
						 		<span v-for="(item,index) in areadata"	@click="areachoosed(item.cityId);"	:class="item.cityId == areaId?'a-screen current' : 'a-screen'">{{item.cityName}}</span>
						 	</dd>
						 </dl>
					</div>
				</div>
				
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" 	@click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
							</div>
					</div>
					<div class="enterprise_list_box" >
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>商会名称</th>
								<th>家乡</th>
								<th>所在地</th>
								<th>企业数</th>
								<th>关注</th>
							</tr>
							<tr v-for="(list,index) in enterpristlist" :key="index" v-if="index<freeUserNum">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<!-- <td v-if="userdata.groupType == 0"><span :class="list.locking?'title onlinetitle td_locktitle locking':'title onlinetitle td_locktitle unlock'" @click="pagelockfun(list.id,list.locking)">{{list.title}}</span><span :class="list.locking?'td_lockimg locking':'td_lockimg unlock'	"></span></td>
								<td v-if="userdata.groupType > 0"><span  class="title onlinetitle" @click="routerlinkid(currentHref,list.id)">{{list.title}}</span></td> -->
								<td><span  class="title onlinetitle" @click="routerlinkid(currentHref,list.id)">{{list.title}}</span></td>
								<td>{{list.hometown}}</td>
								<td>{{list.cityText}}</td>
								<td>{{list.enterpriseNum}}</td>
								<td class="collectfont1"><span  @click="listToggleCollect(list,'acoc')">{{list.collectId == 0?'加入':'移除'}}关注</span></td>
								<!-- <td class="collectfont1"><span  @click="collectToggle(list)"> 加入关注</span></td> -->
							</tr> 
						</table>
						<div class="w95mg"><freeUserTips :type="1" :bgtype="20" v-if="enterpristlist.length>2 && userdata.isFree" ></freeUserTips></div> 
					</div> 
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
			<!-- 解锁试用弹框 -->
			<div class="tipspopbox_bg" v-if="userdata.groupType== 0"  v-show="permissionsbtn" >
				<div class="tipspopbox_acoc"> 
				<span class="closebtn" @click="permissionsbtn=false"></span> 
				<h4 class="numtips">目前剩余可解锁次数：<span class="num">{{permissionsCount}}</span></h4>   <!--     background: linear-gradient(180deg,#fff8e9,#fff);-->
				<strong class="bluetips db">试用账户可免费解锁三家商会<br/>升级至正式版可获得全部访问权限</strong>
				<div class="btnbox">
					<span class="basebtn fl" @click="lockPermission" >确定解锁</span>
					<span class="graybtn fr" @click="permissionsbtn=false">取消</span>
				</div>   
				</div>
			</div>
			<!-- 导出列表弹框 -->
			<div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
					<span class="closebtn" @click="exportpop=false"></span>
				</div>
			</div>
			<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
		</div>
	</div>
</template>
<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
	import {
		dataInJs
	} from "../../utils/city.js";
	export default {
		name: 'commerceList',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				userdata: {},searchtype:1,
				title: '商会列表', 
				searchtext: "",areaId:0,hometid:0,fenkd:{children:[]},  
				areadata:[{areaName:"全国地区",areaId:0},{areaName:'北京市',areaId:11},{areaName:'上海市',areaId:31},{areaName:'广州市',areaId:4401},{areaName:'深圳市',areaId:4403},{areaName:'苏州市',areaId:3205},{areaName:'杭州市',areaId:3301}],
				hometowndata:dataInJs(),
			 notionlist:[],notionlist1:[],notionlist2:[], 
				notiontext: '',notionCode:0,chooseNotionlist:[0,0,0,0,0], 
				kwtextsearch: false,
				kwtextsearchtext: "",
				notionbtn: false,notionbtn1:false,
				enterpristlist:[],
				showscreen: true,
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',
				permissionsbtn:false,//使用账户查看次数权限弹框开关
				permissionsCount:3,//使用账户查看次数权限弹框次数
				currentHref:"/commerceDetail",currentid:0,//点击出现解锁弹框时保存的协会id
				freeUserNum:3,
			}
		},
		components: {
		 freeUserTips
		}, 
		created() {
			this.userdata = this.getuseriformation();
			this.gethometowndata();
			this.freeUserNum=this.userdata.isFree ? 3 : this.pageSize;
		},
		mounted() {
			this.bus.$emit('loading', true);
			this.getareadata();
			this.ajaxsearchcompany();
		},
		methods: {
		//页面最顶部的解锁判断
		pagelockfun(id,lock){
			var currentHref=this.currentHref+id;
			this.currentid=id;
			if(!lock){
				this.routerlinkid(this.currentHref,id); 
			}else{
				if(this.permissionsCount>0){
					this.permissionsbtn=true;
				}else{
					this.bus.$emit('tipspop',{lock:true,type:"permissionNum"});
				};
			} 
			// this.routerself(this.currentHref);
		},
		//确定解锁的判断
		lockPermission(){
			// console.log(this.currentHref,this.permissionsCount);  
			this.permissionsCount--; 
			this.permissionsbtn=false;
			var cuid=this.currentid;
			this.enterpristlist.forEach(list=>{
				if(list.id == cuid){
					list.locking=false;
				}
			})
			this.routerself(this.currentHref+'?id='+this.currentid);
		},
			//获取家乡全部省份
			gethometowndata(){
				var _this=this;
				this.$axios.get(this.$api.cyl.area.get() , {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('获取家乡a',res.data);
					if(res.data.success){
					 _this.hometowndata=res.data.list; 
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//获取所在地
			getareadata(){
				var _this=this;
				this.$axios.get(this.$api.cyl.commerce.city() , {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log('获取所在地a',res.data);
					if(res.data.success){
					 _this.areadata=res.data.list; 
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			
			//获取商会列表
			ajaxsearchcompany(page){
				this.page=page?page:1;
				var _this=this;
				var hometja=this.splicing('hometown',this.hometid);
				var areaja=this.splicing('city',this.areaId);
				var kwja=this.splicing('city',this.searchtext);
				this.$axios.get(this.$api.cyl.commerce.list()+'?page='+this.page+areaja+hometja+kwja , {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('商会列表:',res.data);
					if(res.data.success){
						_this.enterpristlist=res.data.list;
						_this.enterpristlist.forEach(list=>{
							list.locking=!list.unlock;
							// console.log('x',list.hometown)
						}) 
						_this.permissionsCount=res.data.data.unlockRemainder;
						_this.bus.$emit('loading', false);
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.exportnum = res.data.extend.exportRemainder;
					 // _this.areadata=res.data.list; 
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				}); 
			},
			//所在地点击
			areachoosed(id){
				this.areaId=id;
				this.ajaxsearchcompany();
			},
			hometownchoosed(id){
					this.hometid=id;
					this.ajaxsearchcompany();
			},
			//加入、移除目标企业
			collectToggle(list){
				console.log('移除目标企业',list);
				var _this=this,cid=list.collectId;
				var ajaxurl="",ajaxdata={};
				if(cid == 0){
				 ajaxurl=this.$api.cyl.collect.add();
					ajaxdata={type:list.collectType,id:list.id}
					}else{
						ajaxurl=this.$api.cyl.collect.remove();
						ajaxdata={collectId:list.collectId};
					}
					$.ajax({
						type:"POST",
						url:ajaxurl,
						data:ajaxdata,
						headers:{AuthToken:this.userdata.token },
						success:function(res){ 
							// console.log('1123',res);
							if(res.success){
								if(cid == 0){
									list.collectId=res.data.collectId;
								}else{
									list.collectId=0;
								} 
							} 
						} 
					}) 
			},  
			//企业列表导出数据
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				}
				// console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
				// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export()) + '&token=' + this.userdata.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					// console.log('一分钟冷却计时')
				}, 60000)
			}, 
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.ajaxsearchcompany();
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			pageHandler: function(page) {
				if(page>1 && this.userdata.isFree ){
					this.$message({type:'warning',message:"本账号试用期已截止,如需延期请即刻与我们联系"});
					return;
				}
				this.ajaxsearchcompany(page); 
			},
			 
   
		}
	}
</script>

<style>

</style>
